import React from "react";
import { usePageTheme } from "../theme/usePageTheme";
import { V2_LAYOUT } from "../styles/v2Layout";

interface V2HeaderProps {
  title: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

const V2Header: React.FC<V2HeaderProps> = ({ title, left, right }) => {
  const { tokens } = usePageTheme();

  return (
    <div
      style={{
        height: V2_LAYOUT.headerHeight,
        background: tokens.headerBg,
        display: "grid",
        gridTemplateColumns: "44px 1fr 44px",
        alignItems: "center",
        padding: "0 4px",
        flexShrink: 0,
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>{left}</div>
      <div
        style={{
          textAlign: "center",
          fontSize: 16,
          fontWeight: 600,
          color: tokens.text,
          letterSpacing: 0.2,
        }}
      >
        {title}
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>{right}</div>
    </div>
  );
};

export default V2Header;
